import { useMemo } from "react";
import { SORT_TYPES, COUNTRY_FILTERS } from "../config/filters";

/**
 * Custom hook for filtering and sorting products
 * @param {Array} products - Array of products to filter
 * @param {Object} filters - Filter options
 * @param {string} filters.sortType - Sort type (from SORT_TYPES)
 * @param {string} filters.countryFilter - Country filter value
 * @returns {Array} Filtered and sorted products
 */
export const useProductFilters = (products, { sortType, countryFilter }) => {
    const filteredSortedProducts = useMemo(() => {
        if (!products) return [];

        let result = [...products];

        // Apply country filter
        if (countryFilter && countryFilter !== COUNTRY_FILTERS.ALL) {
            if (countryFilter !== COUNTRY_FILTERS.WORLDWIDE) {
                result = result.filter((product) => product.country === countryFilter);
            }
        }

        // Apply sorting
        if (sortType) {
            switch (sortType) {
                case SORT_TYPES.PRICE_ASC:
                    result.sort((a, b) => a.price - b.price);
                    break;
                case SORT_TYPES.PRICE_DESC:
                    result.sort((a, b) => b.price - a.price);
                    break;
                case SORT_TYPES.LOVE_ASC:
                    result.sort((a, b) => a.loveMeter - b.loveMeter);
                    break;
                case SORT_TYPES.LOVE_DESC:
                    result.sort((a, b) => b.loveMeter - a.loveMeter);
                    break;
                default:
                    break;
            }
        }

        return result;
    }, [products, sortType, countryFilter]);

    return filteredSortedProducts;
};
